export enum Env {
  local = 'local',
  dev = 'dev',
  test = 'test',
  prod = 'prod',
}

export interface IEnv {
  environment: Env;
}
